import {useAccessToken} from '@salesforce/commerce-sdk-react'
import {useMemo} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {API} from '../custom-api/api/commerce'

const useCustomApi = () => {
    const {getTokenWhenReady} = useAccessToken()
    const {app, customParams} = getConfig()

    const siteId = app.commerceAPI.parameters.siteId
    const isProduction = customParams?.isProduction ?? false
    const env = app.commerceAPI.parameters.organizationId

    const siteApi = useMemo(
        () =>
            new API({
                env,
                siteId,
                isProduction,
            }),
        [env, siteId, isProduction],
    )

    return {
        /**
         * Retrieves a specific custom object
         *
         * @param {string|string[]} sitePref - The site preference(s) to retrieve.
         * @returns {Promise<any>} - A promise that resolves to the custom preference value(s) for the site preference(s).
         */
        async getCustomObject(customObjectType, key) {
            try {
                const token = await getTokenWhenReady()

                const response = await siteApi.getCustomObject(customObjectType, key, token)
                return response
            } catch (err) {
                console.error(err)
            }
        },
        async getCategoryCompareProducts(categoryId, locale) {
            try {
                const token = await getTokenWhenReady()

                const response = await siteApi.getCategoryCompareProducts(categoryId, locale, token)
                return response
            } catch (err) {
                console.error(err)
            }
        },
        async deleteCustomer(customerId) {
            try {
                const token = await getTokenWhenReady()

                const response = await siteApi.deleteCustomer(token, customerId)

                return response
            } catch (err) {
                console.error(err)
            }
        },
    }
}

export default useCustomApi
